const userId = {
  state: {
    userList: null,
    userState: null,
    autoLogin: false,
  },
  mutations: {
    userListChange: function(state, userList) {
      return (state.userList = userList);
    },
    userStateChange: function(state, userState) {
      return (state.userState = userState);
    },
    autoLoginChange: function(state, autoLogin) {
      return (state.autoLogin = autoLogin);
    },
  },
  getters: {
    getUserList: function(state) {
      return state.userList;
    },
    getUserState: function(state) {
      return state.userState;
    },
    getAutoLogin: function(state) {
      return state.autoLogin;
    },
  },
  actions: {
    setUserListChange(commit, userList) {
      commit("userListChange", userList);
    },
    setUserStateChange(commit, userState) {
      commit("userStateChange", userState);
    },
    setAutoLoginChange(commit, autoLogin) {
      commit("autoLoginChange", autoLogin);
    },
  },
};
export default userId;
